const RouteNames = {
  COURSE_ACCEPT_INVITATION: 'courseAcceptInvitation', // Deprecated in favor of ACCEPT_INVITATION
  S12N_ACCEPT_INVITATION: 's12nAcceptInvitation', // Deprecated in favor of ACCEPT_INVITATION
  ACCEPT_INVITATION: 'acceptInvitation',
  DISCUSSION_GRADING: 'discussionGrading',
  GROUP_MEMBERS: 'groupMembers',
  GROUP_MEMBERS_TEAM: 'groupMembersTeam',
  GROUP_MEMBERS_INVITATION: 'groupMembersInvitation',
  GROUP_EXPORTS: 'groupExports',
  GROUP_SETTINGS: 'groupSettings',
  GROUP_ANNOUNCEMENTS: 'groupAnnouncements',
  GROUP_PERMALINK: 'groupPermalink',
};

export default RouteNames;

export const {
  COURSE_ACCEPT_INVITATION,
  S12N_ACCEPT_INVITATION,
  ACCEPT_INVITATION,
  DISCUSSION_GRADING,
  GROUP_MEMBERS,
  GROUP_MEMBERS_INVITATION,
  GROUP_EXPORTS,
  GROUP_SETTINGS,
  GROUP_ANNOUNCEMENTS,
  GROUP_PERMALINK,
} = RouteNames;
